module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-57x57-7f65ad0b5ae233ebb735af45879b6c4a.png";